import React, { useState } from "react";
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";

// composant pour modifier une relation (link)
export interface EditLinkRowProps {
  child: any;
  allLinks: any[];
  onSave: (childId: string, newLinkId: string) => void;
  onCancel: () => void;
}

const EditLinkRow: React.FC<EditLinkRowProps> = ({
  child,
  allLinks,
  onSave,
  onCancel,
}) => {
  const [selectedLinkId, setSelectedLinkId] = useState(child.link.id);

  return (
    <div className="w-100 mb-3">
      <label
        htmlFor={`link-select-${child.id}`}
        className="form-label fw-medium"
      >
        🔗 Modifier le lien
      </label>
      <div className="d-flex align-items-center gap-2">
        <select
          id={`link-select-${child.id}`}
          className="form-select"
          value={selectedLinkId}
          onChange={(e) => setSelectedLinkId(e.target.value)}
        >
          {allLinks.map((link) => (
            <option
              key={link.id}
              value={link.id}
              selected={link.id === selectedLinkId}
            >
              {link.type}
            </option>
          ))}
        </select>
        <button
          className="btn btn-primary"
          onClick={() => onSave(child.studentParentId, selectedLinkId)}
        >
          Enregistrer
        </button>
        <button className="btn btn-outline-secondary" onClick={onCancel}>
          Annuler
        </button>
      </div>
    </div>
  );
};

export default withPermission(
  EditLinkRow,
  [buildPermission(Resource.PARENT, Action.UPDATE)],
  "masquer",
);
